import { RenderConfigScreenCtx } from 'datocms-plugin-sdk'
import { Canvas, SwitchField } from 'datocms-react-ui'
type PropTypes = {
  ctx: RenderConfigScreenCtx
}
type FirstInstallationParameters = Record<string, unknown>
type ValidParameters = { forceCheckbox: boolean }
type Parameters = FirstInstallationParameters | ValidParameters

export default function ConfigScreen({ ctx }: PropTypes) {
  const parameters = ctx.plugin.attributes.parameters as Parameters
  return (
    <Canvas ctx={ctx}>
      <SwitchField
        id="01"
        name="checkbox"
        label="Enable manually setting missing translations per field?"
        value={parameters.forceCheckbox as boolean}
        onChange={(newValue: any) => {
          ctx.updatePluginParameters({ forceCheckbox: newValue })
          ctx.notice('Settings updated successfully!')
        }}
      />
    </Canvas>
  )
}
